import { useIsDealerGroup } from "../../blocks/DealerGroup/useIsDealerGroup";
import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";
import { useNullableNationalAccountInfo } from "./useNullableNationalAccountInfo";
import { useSearchForm } from "./useSearchForm";

export const useNationalAccountId = (): string => {
  const national = useNullableNationalAccountInfo();
  const dealer = useNullableDealerAccountInfo();
  const isDealerGroup = useIsDealerGroup();
  const [{ nationalAccountId }] = useSearchForm();

  if (dealer) {
    return dealer.dealerNationalAccountId;
  }

  if (isDealerGroup) {
    return nationalAccountId ?? "";
  }

  if (national) {
    return national.nationalAccountId;
  }

  return "";
};
